import axios from 'axios';
import { getAPILocale } from 'src/utils/localization';
import { requestParams, getAPIDomain } from '../constants';
import handleAPIError from '../errors';
import { FetchAttr, UserLocation } from '../types';

const requestUrl = (
  url: string,
  ip: string,
  name: string,
  attr: FetchAttr
): string => {
  const paramsString = new URLSearchParams({
    ...(ip && { ip }),
    ...(name && { name }),
    locale: getAPILocale(attr)
  });
  return `${url}?${paramsString.toString()}`;
};

const requestUrlByCoordinates = (
  url: string,
  longitude: string,
  latitude: string,
  attr: FetchAttr
): string => {
  const paramsString = new URLSearchParams({
    ...(longitude && { longitude }),
    ...(latitude && { latitude }),
    locale: getAPILocale(attr)
  });
  return `${url}?${paramsString.toString()}`;
};

export const searchCitiesByName = async ({
  name,
  attr
}: {
  name?: string;
  attr?: FetchAttr;
}): Promise<UserLocation[]> => {
  const url = requestUrl(`${getAPIDomain()}cities`, null, name, attr);
  try {
    const response = await axios.get(url, requestParams(false, null));
    if (response.status >= 200) {
      return response.data;
    }
    throw response;
  } catch (error) {
    handleAPIError(error, { url });
    return null;
  }
};

export const searchCityByCoordinates = async ({
  longitude,
  latitude,
  attr
}: {
  longitude: number;
  latitude: number;
  attr?: FetchAttr;
}): Promise<UserLocation> => {
  const url = requestUrlByCoordinates(
    `${getAPIDomain()}cities/by/coordinates`,
    longitude.toString(),
    latitude.toString(),
    attr
  );
  try {
    const response = await axios.get(url, requestParams(false, null));
    if (response.status >= 200) {
      return response.data;
    }
    throw response;
  } catch (error) {
    handleAPIError(error, { url });
    return null;
  }
};

export const citiesAPI = async ({
  ip,
  attr
}: {
  ip?: string;
  attr?: FetchAttr;
}): Promise<UserLocation[]> => {
  const url = requestUrl(`${getAPIDomain()}cities`, ip, null, attr);
  try {
    const response = await axios.get(url, requestParams(false, null));
    if (response.status >= 200) {
      return response.data;
    }
    throw response;
  } catch (error) {
    handleAPIError(error, { url });
    return null;
  }
};
